import {locale as defaultLocale} from '@local/stores/dictionaries/route'

export enum DateRange {

	WEEK = 'week',
	MONTH = 'month',
	THREE_MONTHS = 'three-months',
}

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

export const formatDate = (inputDate: string) => {
	const [year, month, day] = inputDate.split(/-| to /)
	return `${day}.${month}.${year.slice(-2)}`
}

/** this returns a string like "march 10 - 14" */
export const dateToMmmDdDd = (startDate: string | Date, endDate: string | Date, locale = defaultLocale.current): [formattedDate: string, formattedStartDate:Date, formattedEndDate:Date] => {
	const [formattedStartDate, formattedEndDate] = getStartEndDate(startDate, endDate)
	const formattedDateString = `${formattedStartDate.toLocaleDateString(locale, {month: 'long'})} ${formattedStartDate.toLocaleDateString(locale, {day: 'numeric'})} - ${formattedEndDate.toLocaleDateString(locale, {day: 'numeric'})}`.toLowerCase()

	return [formattedDateString, formattedStartDate, formattedEndDate]
}

/** this returns a string like "10 march - 14 march 2021" */
export const dateToDdMmmmDdMmmmYyyya = (startDate: string | Date, endDate: string | Date, locale = defaultLocale.current): [formattedDate: string, formattedStartDate:Date, formattedEndDate:Date] => {
	const [formattedStartDate, formattedEndDate] = getStartEndDate(startDate, endDate)
	const formattedDateString = `${formattedStartDate.toLocaleDateString(locale, {month: 'long', day: 'numeric'})} - ${formattedEndDate.toLocaleDateString(locale, {month: 'long', day: 'numeric', year: 'numeric'}).replace(',', '')}`.toLowerCase()

	return [formattedDateString, formattedStartDate, formattedEndDate]
}

export const getStartEndDate = (startDate: string | Date, endDate: string | Date): [Date, Date] => {
	let formattedEndDate = new Date(endDate.trim())
	if (!isDateValid(formattedEndDate)) {
		formattedEndDate = new Date(`${endDate.trim()} ${new Date().getFullYear()}`)
	}

	let formattedStartDate = new Date(startDate.trim())
	if (!isDateValid(formattedStartDate) || formattedStartDate.getFullYear() <= formattedEndDate.getFullYear() - 1) {
		formattedStartDate = new Date(`${startDate.trim()} ${formattedEndDate.getFullYear()}`)
	}
	return [formattedStartDate, formattedEndDate]
}
export const getDateRange = (range: DateRange): Value => {
	const today = new Date()
	if (range === DateRange.WEEK) {
		const tomorrow = new Date(today)
		tomorrow.setDate(today.getDate() + 7)
		return [today, tomorrow]
	} else if (range === DateRange.MONTH) {
		const nextMonth = new Date(today)
		nextMonth.setDate(today.getDate() + 30)
		return [today, nextMonth]
	} else if (range === DateRange.THREE_MONTHS) {
		const nextThreeMonths = new Date(today)
		nextThreeMonths.setDate(today.getDate() + 90)
		return [today, nextThreeMonths]
	}
}

export const formatDateWithLocale = (date: Date, format?: string, locale?: string) => {
	if (!date) return null

	const today = new Date()
	const tomorrow = new Date(today)
	tomorrow.setDate(today.getDate() + 1)
	const yesterday = new Date(today)
	yesterday.setDate(today.getDate() - 1)

	const isSameDay = (d1: Date, d2: Date) =>
		d1.getDate() === d2.getDate() &&
		d1.getMonth() === d2.getMonth() &&
		d1.getFullYear() === d2.getFullYear()

	if (isSameDay(date, today)) {
		return 'Today'
	} else if (isSameDay(date, tomorrow)) {
		return 'Tomorrow'
	} else {
		return date.toLocaleDateString(locale || 'en', {
			day: '2-digit',
			month: 'short',
		})
	}
}
const isDateValid = (dateStr: string|Date) => !isNaN(new Date(dateStr))
